// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: hidden;
}

.app-topbar {
  padding-left: 20px;
  height: 64px;
  padding-right: 20px;
  margin-top: -5px;
  border-bottom: 1px solid #DBDBDB;
  flex-shrink: 0;
}

.topbar-actions {
  display: flex;
  align-items: center;
  color: white;
  gap: 12px;
}

.home-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #f8f9fa;
}
body{
  margin:0px
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #f8f9fa;
}

.loader {
  width: 48px;
  height: 48px;
  border: 4px solid #e3f2fd;
  border-top: 4px solid #1976d2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;
  gap: 20px;
  overflow: hidden;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

/* ── Unified page header bar ─────────────────────────────────────────────── */
.page-header-bar {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.page-header-bar .main-header {
  white-space: nowrap;
  justify-self: start;
}

.header-right-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-self: end;
  flex-shrink: 0;
}

/* ── Master Search wrapper ───────────────────────────────────────────────── */
.master-search-wrapper {
  width: 45%;
  justify-self: center;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.master-search-wrapper:focus-within {
  border-color: #0073cf;
  box-shadow: 0 0 0 3px rgba(0,115,207,0.12), 0 1px 4px rgba(0,0,0,0.08);
}

.master-search-wrapper.active {
  border-color: #0073cf;
  background: #f0f7ff;
}

.master-search-icon {
  display: flex;
  align-items: center;
  padding: 0 10px 0 12px;
  color: #9ca3af;
  flex-shrink: 0;
  transition: color 0.15s;
}

.master-search-wrapper:focus-within .master-search-icon,
.master-search-wrapper.active .master-search-icon {
  color: #0073cf;
}

.search-spinner {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 2px solid #d1d5db;
  border-top-color: #0073cf;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex-shrink: 0;
}

.master-search-input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  padding: 5px 6px;
  font-size: 13px;
  font-family: inherit;
  color: #1a1a1a;
  min-width: 0;
}

.master-search-input::placeholder {
  color: #b0b8c4;
  font-size: 13px;
}

.master-search-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  background: #e5e7eb;
  color: #6b7280;
  cursor: pointer;
  margin: 0 4px;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
  padding: 0;
  margin-right: 0.5rem !important;
}

.master-search-clear:hover {
  background: #fde8e8;
  color: #dc2626;
}

.master-search-btn {
  flex-shrink: 0;
  height: 100%;
  padding: 0 14px;
  background: #0073cf;
  color: #fff;
  border: none;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  letter-spacing: 0.02em;
  transition: background 0.15s;
  border-radius: 0 8px 8px 0;
  min-height: 30px;
 
}

.master-search-btn:hover:not(:disabled) {
  background: #005fa3;
}

.master-search-btn:disabled {
  background: #93c5e8;
  cursor: not-allowed;
}

/* ── Result pill ─────────────────────────────────────────────────────────── */
.master-search-result-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  background: #e8f4fb;
  border: 1px solid #a8d4f0;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #0073cf;
  white-space: nowrap;
}

/* ── Back to filters button ──────────────────────────────────────────────── */
.back-to-filters-btn {
  padding: 5px 13px;
  border: 1.5px solid #0073cf;
  background: transparent;
  color: #0073cf;
  border-radius: 6px;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}

.back-to-filters-btn:hover {
  background: #0073cf;
  color: #fff;
}

/* ── Include Comments toggle ─────────────────────────────────────────────── */
.comments-toggle-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.comments-toggle-label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
  transition: color 0.2s;
}

.comments-toggle-wrap.on .comments-toggle-label {
  color: #0073cf;
}

.toggle-track {
  position: relative;
  width: 36px;
  height: 20px;
  background: #d1d5db;
  border-radius: 20px;
  transition: background 0.22s;
  flex-shrink: 0;
}

.comments-toggle-wrap.on .toggle-track {
  background: #0073cf;
}

.toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.18);
  transition: transform 0.22s cubic-bezier(0.4,0,0.2,1);
}

.comments-toggle-wrap.on .toggle-thumb {
  transform: translateX(16px);
}


@media (max-width: 900px) {
  .page-header-bar {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
  }
  .master-search-wrapper {
    max-width: 100%;
    justify-self: stretch;
  }
  .header-right-actions {
    justify-self: start;
  }
}

.main-header {
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.export-button {
  min-width: 120px;
}

.filters-section {
  flex-shrink: 0;
  background: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filters-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: end;
}

.table-container {
  background: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.table-container.table-loading {
  pointer-events: none;
}

.table-loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(248, 250, 252, 0.8);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  border-radius: 8px;
}

.table-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.8);
}

.table-loader .loader {
  width: 36px;
  height: 36px;
  border: 3px solid #e3f2fd;
  border-top: 3px solid #1976d2;
}

.loading-text {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  letter-spacing: -0.01em;
}

.table-container mc-table {
  display: flex;
  flex-direction: column;
}

.table-container mc-table::part(table-wrapper) {
  flex: 1 1;
  overflow: auto;
  max-height: calc(50vh - 60px);
}

.table-container mc-table::part(header) {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #f5f5f5;
  border-bottom: 2px solid #e0e0e0;
}

.table-cell-content {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  position: relative;
}

.parent-id-link {
  color: #1a5fb4;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.parent-id-link:visited {
  color: #1a5fb4;
}

.lengthy-content {
  cursor: help;
}

.lengthy-content:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: normal;
  max-width: 300px;
  word-wrap: break-word;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.lengthy-content:hover::before {
  content: '';
  position: absolute;
  bottom: 95%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #333;
  z-index: 1000;
}

.pagination-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  padding: 24px 0;
  margin-top: auto;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: transparent;
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: 24px;
}

.pagination-stats {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.results-count {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 15px;
  letter-spacing: -0.01em;
}

.page-indicator {
  font-size: 13px;
  color: #6b7280;
  font-weight: 400;
}

.page-size-select {
  min-width: 90px;
  border-radius: 8px;
}

.pagination-navigation {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-btn {
  border-radius: 8px !important;
  height: 40px !important;
  font-weight: 500 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pagination-btn:hover:not([disabled]) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.page-numbers {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 16px;
  padding: 4px;
  background: rgba(248, 250, 252, 0.8);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.page-number {
  min-width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: #64748b;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  position: relative;
}

.page-number:hover:not(:disabled):not(.active) {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  transform: translateY(-1px);
}

.page-number.active {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.page-number.active::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.05) 100%);
  pointer-events: none;
}

.page-number:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: transparent;
  transform: none;
}

.page-ellipsis {
  padding: 0 8px;
  color: #94a3b8;
  font-size: 14px;
  display: flex;
  align-items: center;
  height: 40px;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 1400px) {
  .filters-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1200px) {
  .filters-row {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .pagination-section {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
    padding: 20px 0;
  }
  
  .pagination-info {
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
  }
  
  .pagination-navigation {
    justify-content: center;
  }
  
  .page-numbers {
    margin: 0 12px;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 16px;
    gap: 16px;
  }
  
  .header-section {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .filters-row {
    grid-template-columns: 1fr;
  }
  
  .main-header {
    font-size: 20px;
    text-align: center;
  }
  
  .pagination-section {
    padding: 16px 0;
    gap: 16px;
  }
  
  .pagination-info {
    gap: 12px;
  }
  
  .pagination-stats {
    text-align: center;
  }
  
  .results-count {
    font-size: 14px;
  }
  
  .page-indicator {
    font-size: 12px;
  }
  
  .page-numbers {
    margin: 0 8px;
    padding: 2px;
    background: rgba(248, 250, 252, 0.6);
  }
  
  .page-number {
    min-width: 36px;
    height: 36px;
    font-size: 13px;
  }
  
  .pagination-btn {
    min-width: 80px !important;
    height: 36px !important;
    font-size: 13px !important;
  }
}

/* Remove any default scrollbars and ensure proper containment */
.home-wrapper, 
.home-container, 
.content-wrapper {
  overflow-x: hidden;
}

/* Ensure table headers remain fixed during scroll */
.table-container mc-table::part(table) {
  border-collapse: separate;
  border-spacing: 0;
}

.table-container mc-table::part(header-cell) {
  background: #f5f5f5;
  font-weight: 600;
  color: #333;
  position: sticky;
  top: 0;
  z-index: 5;
}

/* Enhanced professional styling for filters */
.filters-section::before {
  content: "Filters";
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  font-size: 16px;
}

/* Professional loading states */
.pagination-btn[disabled] {
  opacity: 0.5;
  transform: none !important;
  box-shadow: none !important;
}

.pagination-section.loading {
  opacity: 0.7;
  pointer-events: none;
}

.pagination-section.loading .page-numbers {
  background: rgba(248, 250, 252, 0.4);
}

.pagination-section.loading .page-number {
  opacity: 0.6;
}

.pagination-section.loading .pagination-btn {
  opacity: 0.6;
}


/* ... (Existing CSS remains the same) */

/* New CSS for horizontal date range */
.date-range-horizontal {
  display: flex;
  gap: 16px;
  align-items: flex-end;
}

.date-range-horizontal mc-input-date {
  flex: 1 1;
}

.date-range-horizontal mc-input-date::part(input) {
  width: 100%;
}

/* Ensure the grid layout accommodates the horizontal date range */
.filters-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: end;
}

/* Responsive adjustments */
@media (max-width: 1400px) {
  .filters-row {
    grid-template-columns: repeat(3, 1fr);
  }



}

@media (max-width: 1200px) {
  .filters-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .filters-row {
    grid-template-columns: 1fr;
  }


}
`, "",{"version":3,"sources":["webpack://./src/Components/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;EAC1D,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;EACd,yCAAyC;EACzC,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;;AAElB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,gGAAgG;EAChG,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,oCAAoC;EACtC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA,gEAAgE;AAChE;;;EAGE,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA,wCAAwC;;AAExC,sCAAsC;AACtC;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;;;;AAIF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;;AAGF","sourcesContent":[".home-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  overflow: hidden;\n}\n\n.app-topbar {\n  padding-left: 20px;\n  height: 64px;\n  padding-right: 20px;\n  margin-top: -5px;\n  border-bottom: 1px solid #DBDBDB;\n  flex-shrink: 0;\n}\n\n.topbar-actions {\n  display: flex;\n  align-items: center;\n  color: white;\n  gap: 12px;\n}\n\n.home-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background-color: #f8f9fa;\n}\nbody{\n  margin:0px\n}\n\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  background-color: #f8f9fa;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e3f2fd;\n  border-top: 4px solid #1976d2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.content-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 24px;\n  gap: 20px;\n  overflow: hidden;\n}\n\n.header-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n/* ── Unified page header bar ─────────────────────────────────────────────── */\n.page-header-bar {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.page-header-bar .main-header {\n  white-space: nowrap;\n  justify-self: start;\n}\n\n.header-right-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-self: end;\n  flex-shrink: 0;\n}\n\n/* ── Master Search wrapper ───────────────────────────────────────────────── */\n.master-search-wrapper {\n  width: 45%;\n  justify-self: center;\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n  border: 1.5px solid #d1d5db;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n\n.master-search-wrapper:focus-within {\n  border-color: #0073cf;\n  box-shadow: 0 0 0 3px rgba(0,115,207,0.12), 0 1px 4px rgba(0,0,0,0.08);\n}\n\n.master-search-wrapper.active {\n  border-color: #0073cf;\n  background: #f0f7ff;\n}\n\n.master-search-icon {\n  display: flex;\n  align-items: center;\n  padding: 0 10px 0 12px;\n  color: #9ca3af;\n  flex-shrink: 0;\n  transition: color 0.15s;\n}\n\n.master-search-wrapper:focus-within .master-search-icon,\n.master-search-wrapper.active .master-search-icon {\n  color: #0073cf;\n}\n\n.search-spinner {\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  border: 2px solid #d1d5db;\n  border-top-color: #0073cf;\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n.master-search-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  padding: 5px 6px;\n  font-size: 13px;\n  font-family: inherit;\n  color: #1a1a1a;\n  min-width: 0;\n}\n\n.master-search-input::placeholder {\n  color: #b0b8c4;\n  font-size: 13px;\n}\n\n.master-search-clear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: none;\n  background: #e5e7eb;\n  color: #6b7280;\n  cursor: pointer;\n  margin: 0 4px;\n  flex-shrink: 0;\n  transition: background 0.15s, color 0.15s;\n  padding: 0;\n  margin-right: 0.5rem !important;\n}\n\n.master-search-clear:hover {\n  background: #fde8e8;\n  color: #dc2626;\n}\n\n.master-search-btn {\n  flex-shrink: 0;\n  height: 100%;\n  padding: 0 14px;\n  background: #0073cf;\n  color: #fff;\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  letter-spacing: 0.02em;\n  transition: background 0.15s;\n  border-radius: 0 8px 8px 0;\n  min-height: 30px;\n \n}\n\n.master-search-btn:hover:not(:disabled) {\n  background: #005fa3;\n}\n\n.master-search-btn:disabled {\n  background: #93c5e8;\n  cursor: not-allowed;\n}\n\n/* ── Result pill ─────────────────────────────────────────────────────────── */\n.master-search-result-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  background: #e8f4fb;\n  border: 1px solid #a8d4f0;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #0073cf;\n  white-space: nowrap;\n}\n\n/* ── Back to filters button ──────────────────────────────────────────────── */\n.back-to-filters-btn {\n  padding: 5px 13px;\n  border: 1.5px solid #0073cf;\n  background: transparent;\n  color: #0073cf;\n  border-radius: 6px;\n  font-size: 12.5px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, color 0.15s;\n}\n\n.back-to-filters-btn:hover {\n  background: #0073cf;\n  color: #fff;\n}\n\n/* ── Include Comments toggle ─────────────────────────────────────────────── */\n.comments-toggle-wrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.comments-toggle-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n  white-space: nowrap;\n  transition: color 0.2s;\n}\n\n.comments-toggle-wrap.on .comments-toggle-label {\n  color: #0073cf;\n}\n\n.toggle-track {\n  position: relative;\n  width: 36px;\n  height: 20px;\n  background: #d1d5db;\n  border-radius: 20px;\n  transition: background 0.22s;\n  flex-shrink: 0;\n}\n\n.comments-toggle-wrap.on .toggle-track {\n  background: #0073cf;\n}\n\n.toggle-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.18);\n  transition: transform 0.22s cubic-bezier(0.4,0,0.2,1);\n}\n\n.comments-toggle-wrap.on .toggle-thumb {\n  transform: translateX(16px);\n}\n\n\n@media (max-width: 900px) {\n  .page-header-bar {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto auto;\n  }\n  .master-search-wrapper {\n    max-width: 100%;\n    justify-self: stretch;\n  }\n  .header-right-actions {\n    justify-self: start;\n  }\n}\n\n.main-header {\n  color: #1a1a1a;\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.export-button {\n  min-width: 120px;\n}\n\n.filters-section {\n  flex-shrink: 0;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  padding: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.filters-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  align-items: end;\n}\n\n.table-container {\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.table-container.table-loading {\n  pointer-events: none;\n}\n\n.table-loader-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(248, 250, 252, 0.8);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  border-radius: 8px;\n}\n\n.table-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 24px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.8);\n}\n\n.table-loader .loader {\n  width: 36px;\n  height: 36px;\n  border: 3px solid #e3f2fd;\n  border-top: 3px solid #1976d2;\n}\n\n.loading-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  letter-spacing: -0.01em;\n}\n\n.table-container mc-table {\n  display: flex;\n  flex-direction: column;\n}\n\n.table-container mc-table::part(table-wrapper) {\n  flex: 1;\n  overflow: auto;\n  max-height: calc(50vh - 60px);\n}\n\n.table-container mc-table::part(header) {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: #f5f5f5;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.table-cell-content {\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n  position: relative;\n}\n\n.parent-id-link {\n  color: #1a5fb4;\n  text-decoration: underline;\n  cursor: pointer;\n  display: inline-block;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.parent-id-link:visited {\n  color: #1a5fb4;\n}\n\n.lengthy-content {\n  cursor: help;\n}\n\n.lengthy-content:hover::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #333;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: normal;\n  max-width: 300px;\n  word-wrap: break-word;\n  z-index: 1000;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.lengthy-content:hover::before {\n  content: '';\n  position: absolute;\n  bottom: 95%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #333;\n  z-index: 1000;\n}\n\n.pagination-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 24px 0;\n  margin-top: auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n  background: transparent;\n}\n\n.pagination-info {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.pagination-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.results-count {\n  font-weight: 600;\n  color: #1a1a1a;\n  font-size: 15px;\n  letter-spacing: -0.01em;\n}\n\n.page-indicator {\n  font-size: 13px;\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.page-size-select {\n  min-width: 90px;\n  border-radius: 8px;\n}\n\n.pagination-navigation {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pagination-btn {\n  border-radius: 8px !important;\n  height: 40px !important;\n  font-weight: 500 !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.pagination-btn:hover:not([disabled]) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);\n}\n\n.page-numbers {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 16px;\n  padding: 4px;\n  background: rgba(248, 250, 252, 0.8);\n  border-radius: 12px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.page-number {\n  min-width: 40px;\n  height: 40px;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  outline: none;\n  position: relative;\n}\n\n.page-number:hover:not(:disabled):not(.active) {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n  transform: translateY(-1px);\n}\n\n.page-number.active {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n  transform: translateY(-1px);\n}\n\n.page-number.active::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 8px;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.05) 100%);\n  pointer-events: none;\n}\n\n.page-number:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  background: transparent;\n  transform: none;\n}\n\n.page-ellipsis {\n  padding: 0 8px;\n  color: #94a3b8;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  font-weight: 500;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1400px) {\n  .filters-row {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 1200px) {\n  .filters-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .pagination-section {\n    flex-direction: column;\n    gap: 20px;\n    align-items: stretch;\n    padding: 20px 0;\n  }\n  \n  .pagination-info {\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n  \n  .pagination-navigation {\n    justify-content: center;\n  }\n  \n  .page-numbers {\n    margin: 0 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .content-wrapper {\n    padding: 16px;\n    gap: 16px;\n  }\n  \n  .header-section {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n  \n  .filters-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .main-header {\n    font-size: 20px;\n    text-align: center;\n  }\n  \n  .pagination-section {\n    padding: 16px 0;\n    gap: 16px;\n  }\n  \n  .pagination-info {\n    gap: 12px;\n  }\n  \n  .pagination-stats {\n    text-align: center;\n  }\n  \n  .results-count {\n    font-size: 14px;\n  }\n  \n  .page-indicator {\n    font-size: 12px;\n  }\n  \n  .page-numbers {\n    margin: 0 8px;\n    padding: 2px;\n    background: rgba(248, 250, 252, 0.6);\n  }\n  \n  .page-number {\n    min-width: 36px;\n    height: 36px;\n    font-size: 13px;\n  }\n  \n  .pagination-btn {\n    min-width: 80px !important;\n    height: 36px !important;\n    font-size: 13px !important;\n  }\n}\n\n/* Remove any default scrollbars and ensure proper containment */\n.home-wrapper, \n.home-container, \n.content-wrapper {\n  overflow-x: hidden;\n}\n\n/* Ensure table headers remain fixed during scroll */\n.table-container mc-table::part(table) {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.table-container mc-table::part(header-cell) {\n  background: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n  position: sticky;\n  top: 0;\n  z-index: 5;\n}\n\n/* Enhanced professional styling for filters */\n.filters-section::before {\n  content: \"Filters\";\n  display: block;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 16px;\n  font-size: 16px;\n}\n\n/* Professional loading states */\n.pagination-btn[disabled] {\n  opacity: 0.5;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.pagination-section.loading {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.pagination-section.loading .page-numbers {\n  background: rgba(248, 250, 252, 0.4);\n}\n\n.pagination-section.loading .page-number {\n  opacity: 0.6;\n}\n\n.pagination-section.loading .pagination-btn {\n  opacity: 0.6;\n}\n\n\n/* ... (Existing CSS remains the same) */\n\n/* New CSS for horizontal date range */\n.date-range-horizontal {\n  display: flex;\n  gap: 16px;\n  align-items: flex-end;\n}\n\n.date-range-horizontal mc-input-date {\n  flex: 1;\n}\n\n.date-range-horizontal mc-input-date::part(input) {\n  width: 100%;\n}\n\n/* Ensure the grid layout accommodates the horizontal date range */\n.filters-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  align-items: end;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1400px) {\n  .filters-row {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n\n\n}\n\n@media (max-width: 1200px) {\n  .filters-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .filters-row {\n    grid-template-columns: 1fr;\n  }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
